import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const HeaderCruiseDetails = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const [isFixed, setIsFixed] = useState(false);
  const ref = useRef(null);
  const configuration = useSelector(
    (state) => state.configuration.configuration
  );
  const queryParams = new URLSearchParams(location.search);
  const chainCode = queryParams.get("chainCode");
  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        if (window.scrollY >= 100) {
          setIsFixed(true); // Make it fixed
        } else {
          setIsFixed(false); // Return to original position
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll); // Cleanup on unmount
    };
  }, []);
  return (
    <div>
      <div
        style={{ minHeight: "80px" }}
        ref={ref} // Attach the ref to the div
        className={`singleMenu js-singleMenu  ${isFixed ? "-is-active" : ""}`} // Add a class based on isFixed state
      >
        <div className="container">
          <div className="singleMenu__content row   justify-start g-5 items-center align-items-center">
            <div className="col-auto d-none d-md-flex  me-lg-5">
              <Link
                to={`/?lang=en&chainCode=${chainCode}`}
                className="header-logo mr-20"
                style={{ width: "120px", height: "auto" }}
              >
                {window.location.pathname.includes("/booking") ||
                window.location.pathname.includes("/contact-us") ||
                window.location.pathname.includes("/checkout") ||
                window.location.pathname.includes("/add-extra") ||
                window.location.pathname.includes("/help-center") ||
                window.location.pathname.includes("/signup") ||
                window.location.pathname.includes("/signin") ||
                window.location.pathname.includes("/cruise-type") ||
                window.location.pathname.includes("/cruises-details") ? (
                  <img
                    src={`${
                      configuration?.companyLogo &&
                      configuration?.companyLogo !==
                        "https://cdn.nilecabins.info/images/uploads/"
                        ? configuration?.companyLogo
                        : "nilecabinscom.png"
                    }`}
                    alt={t("common.logoIcon")}
                  />
                ) : (
                  <img
                    src={`${
                      configuration?.companyLogo &&
                      configuration?.companyLogo !==
                        "https://cdn.nilecabins.info/images/uploads/"
                        ? configuration?.companyLogo
                        : "nilecabinscomwhite.png"
                    }`}
                    alt={t("common.logoIcon")}
                  />
                )}
              </Link>
            </div>

            <div className="col-auto">
              <div className="singleMenu__links row x-gap-30 y-gap-10 row align-items-center mx-auto flex-nowrap">
                <div className="col-auto">
                  <Link to={`${location.pathname}${location.search}#overview`}>
                    {t("common.overview")}
                  </Link>
                </div>

                <div className="col-auto">
                  <Link to={`${location.pathname}${location.search}#itinerary`}>
                    {t("common.itinerary")}
                  </Link>
                </div>
                <div className="col-auto">
                  <Link to={`${location.pathname}${location.search}#rooms`}>
                    {t("common.rooms")}
                  </Link>
                </div>
                {/* <div className="col-auto">
                    <Link to="#facilities">Facilities</Link>
                  </div> */}
                <div className="col-auto">
                  <Link to={`${location.pathname}${location.search}#decksPlan`}>
                    {t("common.decksPlan")}
                  </Link>
                </div>
                {/* <div className="col-auto">
                    <Link to="#faq">Faq</Link>
                  </div> */}
              </div>
            </div>

            {/* <div className="col-auto">
                <div className="row x-gap-15 y-gap-15 items-center">
                   

                  <div className="col-auto">
                    <Link
                      to={`${location.pathname}${location.search}#rooms`}
                      className="button h-50 px-24 -dark-1 bg-blue-1 text-white"
                    >
                      Select Room{" "}
                      <div className="icon-arrow-top-right ml-15"></div>
                    </Link>
                  </div>
                </div>
              </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderCruiseDetails;
